import React from 'react'
import Header from "../../Component/privacypolicy/privacyheader/Header"
import Bodytext from "../../Component/privacypolicy/privacybody/Bodytext"
import Footer from "../../Component/privacypolicy/privacyfooter/Privacyfooter"

const Privacy = () => {
    return (
        <div>
            <Header />
            <Bodytext />
            <Footer />
            
        </div>
    )
}

export default Privacy
